/* src/app/rt-components/breadcrumb/breadcrumb.component.scss */
:host {
  display: block;
}
:host .breadcrumb {
  display: flex;
  flex-wrap: wrap;
  font-size: 1.2rem;
  list-style-type: none;
  margin: 0;
  padding: 0;
}
@media screen and (max-width: 767px) {
  :host .breadcrumb {
    font-size: 1rem;
  }
}
:host .breadcrumb li a .icon,
:host .breadcrumb li .static .icon {
  font-size: 1rem;
  margin-right: 6px;
}
.rtl :host .breadcrumb li a .icon,
.rtl :host .breadcrumb li .static .icon {
  margin-left: 6px;
  margin-right: 0;
}
:host .breadcrumb li .separator {
  color: rgba(0, 0, 0, 0.4);
  margin: 0 0.7857143rem;
}
:host .breadcrumb.custom-1 {
  margin: -2px -7px;
}
@media screen and (max-width: 767px) {
  :host .breadcrumb.custom-1 {
    margin-left: -2px;
    margin-right: -2px;
  }
}
:host .breadcrumb.custom-1 li {
  margin: 2px 7px;
}
@media screen and (max-width: 767px) {
  :host .breadcrumb.custom-1 li {
    margin-left: 2px;
    margin-right: 2px;
  }
}
:host .breadcrumb.custom-1 li a,
:host .breadcrumb.custom-1 li .static {
  background: #5dade0;
  border-color: #5dade0;
  color: #fff;
  display: inline-block;
  height: 36px;
  padding: 5px 1.5714286rem;
  position: relative;
  transition: background 0.2s ease-in-out, color 0.2s ease-in-out;
  vertical-align: top;
}
@media screen and (max-width: 767px) {
  :host .breadcrumb.custom-1 li a,
  :host .breadcrumb.custom-1 li .static {
    height: auto;
    padding: 2px 0.7857143rem;
  }
}
:host .breadcrumb.custom-1 li a:before,
:host .breadcrumb.custom-1 li a:after,
:host .breadcrumb.custom-1 li .static:before,
:host .breadcrumb.custom-1 li .static:after {
  border-style: solid;
  border-color: transparent;
  content: "";
  display: block;
  height: 0px;
  position: absolute;
  top: 0px;
  transition: border-color 0.2s ease-in-out;
  width: 0px;
}
@media screen and (max-width: 767px) {
  :host .breadcrumb.custom-1 li a:before,
  :host .breadcrumb.custom-1 li a:after,
  :host .breadcrumb.custom-1 li .static:before,
  :host .breadcrumb.custom-1 li .static:after {
    display: none;
  }
  .rtl :host .breadcrumb.custom-1 li a:before,
  .rtl :host .breadcrumb.custom-1 li a:after,
  .rtl :host .breadcrumb.custom-1 li .static:before,
  .rtl :host .breadcrumb.custom-1 li .static:after {
    display: none !important;
  }
}
:host .breadcrumb.custom-1 li a:before,
:host .breadcrumb.custom-1 li .static:before {
  border-width: 36px 10px 0 0;
  border-right-color: inherit;
  left: -10px;
}
:host .breadcrumb.custom-1 li a:after,
:host .breadcrumb.custom-1 li .static:after {
  border-width: 0 0 36px 10px;
  border-left-color: inherit;
  right: -10px;
}
:host .breadcrumb.custom-1 li a:hover {
  background: #fff;
  border-color: #fff;
  color: #5dade0;
}
:host .breadcrumb.custom-1 li .static {
  opacity: 0.6;
}
:host .breadcrumb.custom-1 li .separator {
  display: none;
}
:host .breadcrumb.custom-1 li:first-child a:before,
:host .breadcrumb.custom-1 li:first-child .static:before {
  display: none;
}
.rtl :host .breadcrumb.custom-1 li:first-child a:before,
.rtl :host .breadcrumb.custom-1 li:first-child .static:before {
  display: block;
}
.rtl :host .breadcrumb.custom-1 li:first-child a:after,
.rtl :host .breadcrumb.custom-1 li:first-child .static:after {
  display: none;
}
:host .breadcrumb.custom-1 li:last-child a:after,
:host .breadcrumb.custom-1 li:last-child .static:after {
  display: none;
}
.rtl :host .breadcrumb.custom-1 li:last-child a:before,
.rtl :host .breadcrumb.custom-1 li:last-child .static:before {
  display: none;
}
.rtl :host .breadcrumb.custom-1 li:last-child a:after,
.rtl :host .breadcrumb.custom-1 li:last-child .static:after {
  display: block;
}
:host .breadcrumb.custom-2 {
  margin: -2px -7px;
}
@media screen and (max-width: 767px) {
  :host .breadcrumb.custom-2 {
    margin-left: -2px;
    margin-right: -2px;
  }
}
:host .breadcrumb.custom-2 li {
  margin: 2px 7px;
}
@media screen and (max-width: 767px) {
  :host .breadcrumb.custom-2 li {
    margin-left: 2px;
    margin-right: 2px;
  }
}
:host .breadcrumb.custom-2 li a,
:host .breadcrumb.custom-2 li .static {
  background: #5dade0;
  border-color: #5dade0;
  color: #fff;
  display: inline-block;
  height: 36px;
  padding: 5px 1.5714286rem;
  position: relative;
  transition: background 0.2s ease-in-out, color 0.2s ease-in-out;
  vertical-align: top;
}
@media screen and (max-width: 767px) {
  :host .breadcrumb.custom-2 li a,
  :host .breadcrumb.custom-2 li .static {
    height: auto;
    padding: 2px 0.7857143rem;
  }
}
:host .breadcrumb.custom-2 li a:before,
:host .breadcrumb.custom-2 li a:after,
:host .breadcrumb.custom-2 li .static:before,
:host .breadcrumb.custom-2 li .static:after {
  border-style: solid;
  border-color: transparent;
  content: "";
  display: block;
  height: 0px;
  position: absolute;
  top: 0px;
  transition: border-color 0.2s ease-in-out;
  width: 0px;
}
@media screen and (max-width: 767px) {
  :host .breadcrumb.custom-2 li a:before,
  :host .breadcrumb.custom-2 li a:after,
  :host .breadcrumb.custom-2 li .static:before,
  :host .breadcrumb.custom-2 li .static:after {
    display: none;
  }
}
:host .breadcrumb.custom-2 li a:before,
:host .breadcrumb.custom-2 li .static:before {
  border-width: 18px 0 18px 10px;
  border-top-color: inherit;
  border-bottom-color: inherit;
  left: -10px;
}
.rtl :host .breadcrumb.custom-2 li a:before,
.rtl :host .breadcrumb.custom-2 li .static:before {
  border-style: solid;
  border-color: transparent;
  border-width: 18px 0 18px 10px;
  border-left-color: inherit;
  left: auto;
  right: -10px;
}
:host .breadcrumb.custom-2 li a:after,
:host .breadcrumb.custom-2 li .static:after {
  border-width: 18px 0 18px 10px;
  border-left-color: inherit;
  right: -10px;
}
.rtl :host .breadcrumb.custom-2 li a:after,
.rtl :host .breadcrumb.custom-2 li .static:after {
  border-style: solid;
  border-color: transparent;
  border-width: 18px 0 18px 10px;
  border-top-color: inherit;
  border-bottom-color: inherit;
  left: -10px;
  right: auto;
}
:host .breadcrumb.custom-2 li a:hover {
  background: #fff;
  border-color: #fff;
  color: #5dade0;
}
:host .breadcrumb.custom-2 li .static {
  opacity: 0.6;
}
:host .breadcrumb.custom-2 li .separator {
  display: none;
}
:host .breadcrumb.custom-2 li:first-child a:before,
:host .breadcrumb.custom-2 li:first-child .static:before {
  display: none;
}
:host .breadcrumb.custom-2 li:last-child a:after,
:host .breadcrumb.custom-2 li:last-child .static:after {
  display: none;
}
/*# sourceMappingURL=breadcrumb.component.css.map */
